/* eslint-disable sort-keys */
export const countryStates = {
  US: [
    {
      label: 'Alaska',
      value: 'AK',
    },
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'District of Columbia',
      value: 'DC ',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },
    {
      label: 'Florida',
      value: 'FL',
    },
    {
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    {
      label: 'Louisiana',
      value: 'LA',
    },
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },
    {
      label: 'Montana',
      value: 'MT',
    },
    {
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    {
      label: 'New York',
      value: 'NY',
    },
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Puerto Rico',
      value: 'PR',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },
    {
      label: 'Texas',
      value: 'TX',
    },
    {
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Virgin Islands',
      value: 'VI',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },
  ],
  England: [],
  Australia: [],
  Canada: [],
  'New Zealand': [],
  Singapore: [],
  Ireland: [],
  Mexico: [],
  Switzerland: [],
  Sweden: [],
  Portugal: [],
  Italy: [],
  Norway: [],
  Netherlands: [],
  France: [],
  Finland: [],
  Estonia: [],
  Denmark: [],
  Croatia: [],
  Belgium: [],
  Spain: [],
  Poland: [],
  Germany: [],
  UAE: [],
  India: [],
  'South Africa': [],
  Austria: [],
  Argentina: [],
  Brazil: [],
  Brunei: [],
  Bulgaria: [],
  Chile: [],
  'Czech Republic': [],
  Egypt: [],
  Greece: [],
  Hungary: [],
  Indonesia: [],
  Israel: [],
  Japan: [],
  Luxembourg: [],
  Malaysia: [],
  Philippines: [],
  Qatar: [],
  Romania: [],
  'Saudi Arabia': [],
  Slovakia: [],
  Slovenia: [],
  'South Korea': [],
  Taiwan: [],
  Thailand: [],
  Turkey: [],
  Vietnam: [],
  Nigeria: [],
  Bangladesh: [],
  Ethiopia: [],
  Congo: [],
  Tanzania: [],
  Myanmar: [],
  Kenya: [],
  Algeria: [],
  Uganda: [],
  Morocco: [],
  Angola: [],
  Ghana: [],
  Mozambique: [],
  Peru: [],
  Uzbekistan: [],
  Nepal: [],
  Cameroon: [],
  'Cote d`Ivoire': [],
  Madagascar: [],
  Niger: [],
  'Sri Lanka': [],
  'Burkina Faso': [],
  Mali: [],
  Malawi: [],
  Zambia: [],
  Kazakhstan: [],
  Chad: [],
  Senegal: [],
  Guatemala: [],
  Ecuador: [],
  Cambodia: [],
  'Hong Kong': [],
  Serbia: [],
  'El Salvador': [],
  Cyprus: [],
  Iceland: [],
  Bahamas: [],
  Aruba: [],
  Barbados: [],
  'Virgin Islands': [],
  'Isle of Man': [],
  'Marshall Islands': [],
  Bermuda: [],
  'Cayman Islands': [],
  Liechtenstein: [],
  'British Virgin Islands': [],
  Monaco: [],
}

export const hifiStates = {
  USA: [
    /*{
      label: 'Alaska',
      value: 'AK',
    },*/
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'District of Columbia',
      value: 'DC ',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },
    /*{
      label: 'Florida',
      value: 'FL',
    },*/
    {
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    /*{
      label: 'Louisiana',
      value: 'LA',
    },*/
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },
    {
      label: 'Montana',
      value: 'MT',
    },
    {
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    /*{
      label: 'New York',
      value: 'NY',
    },*/
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Puerto Rico',
      value: 'PR',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },
    {
      label: 'Texas',
      value: 'TX',
    },
    {
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Virgin Islands',
      value: 'VI',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },
  ],
  /*England: [],
  Australia: [],
  Canada: [],
  'New Zealand': [],
  Singapore: [],
  Ireland: [],
  Mexico: [],
  Switzerland: [],
  Sweden: [],
  Portugal: [],
  Italy: [],
  Norway: [],
  Netherlands: [],
  France: [],
  Finland: [],
  Estonia: [],
  Denmark: [],
  Croatia: [],
  Belgium: [],
  Spain: [],
  Poland: [],
  Germany: [],
  UAE: [],
  India: [],
  'South Africa': [],
  Austria: [],
  Argentina: [],
  Brazil: [],
  Brunei: [],
  Bulgaria: [],
  Chile: [],
  'Czech Republic': [],
  Egypt: [],
  Greece: [],
  Hungary: [],
  Indonesia: [],
  Israel: [],
  Japan: [],
  Luxembourg: [],
  Malaysia: [],
  Philippines: [],
  Qatar: [],
  Romania: [],
  'Saudi Arabia': [],
  Slovakia: [],
  Slovenia: [],
  'South Korea': [],
  Taiwan: [],
  Thailand: [],
  Turkey: [],
  Vietnam: [],
  Nigeria: [],
  Bangladesh: [],
  Ethiopia: [],
  Congo: [],
  Tanzania: [],
  Myanmar: [],
  Kenya: [],
  Algeria: [],
  Uganda: [],
  Morocco: [],
  Angola: [],
  Ghana: [],
  Mozambique: [],
  Peru: [],
  Uzbekistan: [],
  Nepal: [],
  Cameroon: [],
  'Cote d`Ivoire': [],
  Madagascar: [],
  Niger: [],
  'Sri Lanka': [],
  'Burkina Faso': [],
  Mali: [],
  Malawi: [],
  Zambia: [],
  Kazakhstan: [],
  Chad: [],
  Senegal: [],
  Guatemala: [],
  Ecuador: [],
  Cambodia: [],
  'Hong Kong': [],
  Serbia: [],
  'El Salvador': [],
  Cyprus: [],
  Iceland: [],
  Bahamas: [],
  Aruba: [],
  Barbados: [],
  'Virgin Islands': [],
  'Isle of Man': [],
  'Marshall Islands': [],
  Bermuda: [],
  'Cayman Islands': [],
  Liechtenstein: [],
  'British Virgin Islands': [],
  Monaco: [],*/
}

export const wireStates = {
  US: [
    {
      label: 'Alaska',
      value: 'AK',
    },
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'District of Columbia',
      value: 'DC ',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },
    {
      label: 'Florida',
      value: 'FL',
    },
    {
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    {
      label: 'Louisiana',
      value: 'LA',
    },
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },
    {
      label: 'Montana',
      value: 'MT',
    },
    {
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    {
      label: 'New York',
      value: 'NY',
    },
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Puerto Rico',
      value: 'PR',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },
    {
      label: 'Texas',
      value: 'TX',
    },
    {
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Virgin Islands',
      value: 'VI',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },
  ],
  England: [],
  Australia: [],
  Canada: [],
  'New Zealand': [],
  Singapore: [],
  Ireland: [],
  Mexico: [],
  Switzerland: [],
  Sweden: [],
  Portugal: [],
  Italy: [],
  Norway: [],
  Netherlands: [],
  France: [],
  Finland: [],
  Estonia: [],
  Denmark: [],
  Croatia: [],
  Belgium: [],
  Spain: [],
  Poland: [],
  Germany: [],
  UAE: [],
  India: [],
  'South Africa': [],
  Austria: [],
  Argentina: [],
  Brazil: [],
  Brunei: [],
  Bulgaria: [],
  Chile: [],
  'Czech Republic': [],
  Egypt: [],
  Greece: [],
  Hungary: [],
  Indonesia: [],
  Israel: [],
  Japan: [],
  Luxembourg: [],
  Malaysia: [],
  Philippines: [],
  Qatar: [],
  Romania: [],
  'Saudi Arabia': [],
  Slovakia: [],
  Slovenia: [],
  'South Korea': [],
  Taiwan: [],
  Thailand: [],
  Turkey: [],
  Vietnam: [],
  Nigeria: [],
  Bangladesh: [],
  Ethiopia: [],
  Congo: [],
  Tanzania: [],
  Myanmar: [],
  Kenya: [],
  Algeria: [],
  Uganda: [],
  Morocco: [],
  Angola: [],
  Ghana: [],
  Mozambique: [],
  Peru: [],
  Uzbekistan: [],
  Nepal: [],
  Cameroon: [],
  'Cote d`Ivoire': [],
  Madagascar: [],
  Niger: [],
  'Sri Lanka': [],
  'Burkina Faso': [],
  Mali: [],
  Malawi: [],
  Zambia: [],
  Kazakhstan: [],
  Chad: [],
  Senegal: [],
  Guatemala: [],
  Ecuador: [],
  Cambodia: [],
  'Hong Kong': [],
  Serbia: [],
  'El Salvador': [],
  Cyprus: [],
  Iceland: [],
  Bahamas: [],
  Aruba: [],
  Barbados: [],
  'Virgin Islands': [],
  'Isle of Man': [],
  'Marshall Islands': [],
  Bermuda: [],
  'Cayman Islands': [],
  Liechtenstein: [],
  'British Virgin Islands': [],
  Monaco: [],
}

export const buyStates = {
  US: [
    /*{
      label: 'Alaska',
      value: 'AK',
    },
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'District of Columbia',
      value: 'DC ',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },*/
    /*{
      label: 'Florida',
      value: 'FL',
    },*/
    /*{
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    {
      label: 'Louisiana',
      value: 'LA',
    },
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },*/
    /*{
      label: 'Montana',
      value: 'MT',
    },*/
    /*{
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    {
      label: 'New York',
      value: 'NY',
    },
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Puerto Rico',
      value: 'PR',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },*/
    {
      label: 'Texas',
      value: 'TX',
    },
    /*{
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Virgin Islands',
      value: 'VI',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },*/
    {
      label: 'Missing',
      value: 'missing',
    },
    {
      label: 'Empty',
      value: '',
    },
    {
      label: 'Null',
      value: null,
    },
  ],
}

export const mtlStates = {
  AL: 1,
  AK: 1,
  AS: 1,
  AZ: 0,
  AR: 0,
  CA: 0,
  CO: 0,
  CT: 0,
  DE: 1,
  DC: 1,
  FL: 1,
  GA: 0,
  GU: 1,
  HI: 0,
  ID: 1,
  IL: 0,
  IN: 0,
  IA: 0,
  KS: 0,
  KY: 1,
  LA: 1,
  ME: 0,
  MD: 1,
  MA: 0,
  MI: 1,
  MN: 0,
  MS: 0,
  MO: 0,
  MT: 0,
  NE: 0,
  NV: 0,
  NH: 0,
  NJ: 1,
  NM: 1,
  NY: 1,
  NC: 1,
  ND: 0,
  MP: 1,
  OH: 1,
  OK: 1,
  OR: 1,
  PA: 0,
  PR: 1,
  RI: 0,
  SC: 0,
  SD: 0,
  TN: 0,
  TX: 0,
  UT: 0,
  VI: 1,
  VT: 0,
  VA: 0,
  WA: 1,
  WV: 0,
  WI: 0,
  WY: 0,
  missing: 2,
}
